<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <FullCalendar :options="calendarOptions" />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import "@fullcalendar/core/vdom"; // solves problem with Vite
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import timeGridPlugin from "@fullcalendar/timegrid";
import FullCalendar from "@fullcalendar/vue";
import { format } from "date-fns";
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  name: "TodoList",
  components: { FullCalendar },
  computed: {
    showIt() {
      return this.$route.query.showIt;
    }
  },
  data: function() {
    return {
      itUsers: [],
      calendarOptions: {
        // displayEventEnd: true,
        themeSystem: "standard",
        height: "auto",
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        eventDisplay: "auto",
        eventClick: this.handleEventClick,
        nextDayThreshold: "09:00:00",
        displayEventTime: false,
        // dateClick: this.handleDateClick,
        events: []
      },
      users: [
        { label: "Goran", value: "1125" },
        { label: "Vladimir", value: "1211" }
      ],
      image: { blank: false, width: 55, height: 55, class: "" },
      showArchived: false,
      selectedCategory: "1",
      calibrations: []
    };
  },
  watch: {
    "$route.query"() {
      this.fetchData(true);
    }
  },
  methods: {
    handleEventClick(arg) {
      console.log(arg.event.id);
      this.$router.push(`/base/TodoList-Details/?task=${arg.event.id}`);
    },
    // handleDateClick (arg) {
    //   this.$refs.addCalibration.showModal = true
    //   this.$refs.addCalibration.dateTime = arg.dateStr
    //   this.$refs.addCalibration.fetchData()
    // },
    parseText(data) {
      return data.replace(/&quot;/g, '"').replace(/&amp;/g, "&");
    },

    parseColor(user, task) {
      if (task.status === "2") {
        return "#2ecc71";
      } else {
        if (user[0].badge === "1224") {
          return "#3498db";
        } else if (user[0].badge === "1211") {
          return "#e67e22";
        } else if (user[0].badge === "1288") {
          return "#2bcbba";
        } else if (user[0].badge === "1295") {
          return "#9b59b6";
        }
      }
    },

    fetchData() {
      const params = {
        onlyMine: this.onlyMine,
        category: this.showIt === "1" ? 0 : 1
        // category: 0
      };
      let url = "api/fns/todoList/listItems.php";
      if (this.showArchived) {
        url = "api/fns/todoList/listArchivedItems.php";
      }
      this.$http.get(url, { params }).then(
        res => {
          console.log("res", res);
          const data = res.data.filter(e => e.status !== "0" && e.start_date);

          const tasks = data.map(e => {
            if (e.status !== "0") {
              const userOnTask = this.itUsers.filter(
                user => user.badge === e.user_on_task
              );
              let title = e.desc;
              const endDate = e.end_date
                ? format(new Date(e.end_date), "yyyy-MM-dd H:mm:ss")
                : format(new Date(), "yyyy-MM-dd 23:00:00");

              if (userOnTask[0] && userOnTask[0].name) {
                title = `${e.task_id} - ${userOnTask[0].name} - ${e.desc}`;
              }

              return {
                id: e.task_id,
                title: title,
                start: format(new Date(e.start_date), "yyyy-MM-dd"),
                end: endDate,
                color:
                  userOnTask.length > 0 ? this.parseColor(userOnTask, e) : ""
              };
            }
          });
          console.log("tasks", tasks);
          this.calendarOptions.events = tasks;
        },
        err => {
          console.log(err);
        }
      );

      this.$http.get("api/fns/todoList/portalUsers.php").then(
        res => {
          this.users = res.data;
        },
        err => {
          this.loadingTodo = false;
          this.loadingInProgress = false;
          this.loadingDone = false;
          console.log(err);
        }
      );
    },
    fetchUsers() {
      this.$http.get("api/fns/todoList/portalUsers.php").then(
        res => {
          console.log("ress users", res);
          // this.users = res.data
          const itUsers = [];
          res.data.forEach(user => {
            if (
              user.badge === "1224" ||
              user.badge === "1211" ||
              user.badge === "1288" ||
              user.badge === "1295"
            ) {
              itUsers.push(user);
            }
          });
          this.itUsers = itUsers;
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );
    },

    openDetails(task) {
      this.$router.push("/base/TodoList-Details/?task=" + task.task_id);
    }
  },

  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    this.fetchUsers();
    this.fetchData();
  }
};
</script>

<style>
.priority-popover {
  background-color: #3a4149;
}

.priority-popover .popover-header {
  background-color: #3a4149;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}

.priority-btn {
  color: white;
  border: none !important;
  margin-top: 5px;
  padding: 0;
}

.task {
  border: 3px solid #2f353a;
  background: #2f353a;
  border-radius: 5px;
  padding: 20px 10px 20px 1px;
  margin: 20px 2px;
  cursor: pointer;
}

.task-title {
  font-size: 16px;
}

.priority {
  cursor: pointer;
  padding: 12px;
  margin: 7px;
}

.priority-info {
  cursor: pointer;
  margin-left: 3px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
}

/*.popover {*/
/*  background: #3a4149 !important;*/
/*  color: white*/
/*}*/
/*.popover-header {*/
/*  background: #3a4149 !important;*/
/*}*/
.bs-popover-right > .arrow::before,
.bs-popover-auto[x-placement^="right"] > .arrow::before {
  border-right-color: #3a4149;
}

.bs-popover-right > .arrow::after,
.bs-popover-auto[x-placement^="right"] > .arrow::after {
  border-right-color: #3a4149;
}

.spinner {
  height: 55px;
  width: 55px;
  display: block;
  margin: auto;
  margin-top: 50px;
}

.custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #2b2b2b !important;
  background: #515b65 !important;
  color: #ffffff38 !important;
}

.custom-file-input ~ .custom-file-label {
  border-color: #2b2b2b !important;
  background: #515b65 !important;
  color: white !important;
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
  display: none !important;
}

.fc-col-header {
  background: #3a4149 !important;
}
.fc-daygrid-day {
  border: 1px solid #5c6369 !important;
}

/*.fc-scrollgrid {*/
/*  border: 1px solid #5c6369 !important;*/
/*}*/
</style>
